const PasswordsNotMatchedError = () => {
    return <span>Passwords do not match.</span>;
};

export default PasswordsNotMatchedError;
